import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { addIVRExtensionUser, getIVRExtension, getUser, getUserRole, updateIVRExtensionUser } from "../../../services/userMasterUser";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";

export default function IVRExtensionUserCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [input, setInput] = useState({
    action: state?.action || "",
    userId: state?.user.id || "",
    ivrLeadExtensionId: state?.ivrLeadExtension.id || "",
    status: state?.status || true,
  });
  const [errors, setErrors] = useState({
    action: "",
    userId: "",
    ivrLeadExtensionId: "",
    status: "",
  });

  useEffect(() => {
    if (state) {
      setInput(prevState => ({
        ...prevState,
        status: state?.status,
        userId: state?.user.id,
        ivrLeadExtensionId: state?.ivrLeadExtension.id
      }));
    }
  }, [state]);

  const [userListData, setUserListData] = useState([])
  const [ivrLeadExtensionIdListData, setIvrLeadExtensionIdListData] = useState([])

  const [userRoleData, setUserRoleData] = useState([]);
  const [userRoleValue, setUserRoleValue] = useState([
    'ROLE_TELECALLER',
    ...(state?.user?.role ? [state.user.role] : [])
  ]);

  const fetchUsers = (userData) => {
    getUser(userData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const userStatus = Res.map((item) => ({
            label: item.userName + " - " + item?.userTypeInfo,
            value: item.id,
          }));
          setUserListData(userStatus)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })
      .finally(() => console.log(false));
  }

  useEffect(() => {

    getUserRole()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const services = Res.map((item) => ({
            label: item.roleName,
            value: item.roleName,
          }));
          setUserRoleData(services);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });


    const userData = {
      name: "",
      category: "",
      searchBy: "",
      searchText: "",
      roleIn: userRoleValue,
    };

    fetchUsers(userData)
    

    const IVRExtensionData = {
      searchBy: "",
      searchText: "",
      limit: 20,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      activee: true,
      statusIn: []
    };

    getIVRExtension(IVRExtensionData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const leadSource = Res.map((item) => ({
            label: item.extension,
            value: item.id,
          }));


          setIvrLeadExtensionIdListData(leadSource)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })
      .finally(() => console.log(false));
  }, [])



  const [statusData, setStatusData] = useState([
    { label: "ACTIVE", value: true },
    { label: "INACTIVE", value: false }
  ]);

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;

    if (!(input.action)) {
      newErrors.action = "Please Enter Action";
      isValid = false;
    } else {
      newErrors.action = "";
    }


    if (!(input.userId)) {
      newErrors.userId = "Please Enter User";
      isValid = false;
    } else {
      newErrors.userId = "";
    }


    if (!(input.ivrLeadExtensionId)) {
      newErrors.ivrLeadExtensionId = "Please Enter IVR Lead Extension";
      isValid = false;
    } else {
      newErrors.ivrLeadExtensionId = "";
    }




    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (state) {
        let data = {
          id: state?.id,
          user: {
            id: input.userId
          },
          ivrLeadExtension: {
            id: state?.ivrLeadExtension?.id
          },
          action: input.action,
          status: input.status,
        };
        updateIVRExtensionUser(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                errorMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/IVRExtensionUser/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      } else {
        let data = {
          user: {
            id: input.userId
          },
          ivrLeadExtension: {
            id: input.ivrLeadExtensionId
          },
          action: input.action,
          status: true

        };
        addIVRExtensionUser(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                errorMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/IVRExtensionUser/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      }
    }
  };

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/user-master/IVRExtensionUser/list")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> IVR Extension User {state ? "Update" : "Create"}
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Action
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="action"
                        name="action"
                        value={input.action}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            action: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.action}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="role" className="form-label">
                        Role
                      </label>
                      <MultiSelect
                        style={{ width: "100%" }}
                        value={userRoleValue}
                        onChange={(e) => {setUserRoleValue(e.value)
                          const userData = {
                            name: "",
                            category: "",
                            searchBy: "",
                            searchText: "",
                            roleIn: e.value,
                          };

                          fetchUsers(userData)
                        }}
                        options={userRoleData}
                        optionLabel="label"
                        placeholder="Select User"
                      />

                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="user" className="form-label">
                        User
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={userListData}
                        value={input.userId}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            userId: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.userId}</div>
                    </div>
                    {!state && <div className="col-md-6">
                      <label htmlFor="status" className="form-label">
                        IVR Lead Extension
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={ivrLeadExtensionIdListData}
                        value={input.ivrLeadExtensionId}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            ivrLeadExtensionId: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.ivrLeadExtensionId}</div>
                    </div>}

                   
                    {state?.id && <div className="col-md-6">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={statusData}
                        value={input.status}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            status: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.status}</div>
                    </div>}
                  </div>
                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-blue">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
